<div id="twelveMonthInspectionChart"></div>
